import { render, staticRenderFns } from "./utime.vue?vue&type=template&id=5293a8be&"
import script from "./utime.vue?vue&type=script&lang=js&"
export * from "./utime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports